import React, { useState } from 'react';
import Modal from './ui/Modal';
import { api } from '../api';

/**
 * Modal de "esqueci minha senha" aberto a partir do login.
 * Chama POST /auth/esqueci-senha e mostra mensagem genérica (não revela se o email existe).
 */
export default function ModalEsqueciSenha({ emailInicial = '', onClose }) {
  const [email, setEmail] = useState(emailInicial);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      await api.esqueciSenha(email.trim());
      setEnviado(true);
    } catch (err) {
      setErro(err.message || 'Não foi possível enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      titulo="Recuperar senha"
      onClose={enviado ? undefined : onClose}
      bloqueado={loading}
      largura={420}
      rodape={enviado ? (
        <button type="button" className="btn-primary" onClick={onClose} style={{ width: '100%', justifyContent: 'center' }}>
          Voltar ao login
        </button>
      ) : undefined}
    >
      {enviado ? (
        <div className="msg msg-success" style={{ marginBottom: 0 }}>
          Se o email informado estiver cadastrado, enviaremos as
          instruções de recuperação. Verifique sua caixa de entrada e o spam.
          O link vale por 1 hora.
        </div>
      ) : (
        <>
          <p style={{ margin: '0 0 1rem', fontSize: '0.85rem', color: 'var(--text-muted)', lineHeight: 1.5 }}>
            Informe o email da conta. Se estiver cadastrado, enviaremos um link
            para criar uma nova senha.
          </p>
          {erro && <div className="msg msg-error">{erro}</div>}
          <form onSubmit={handleSubmit} autoComplete="on">
            <div style={{ marginBottom: '1.25rem' }}>
              <label htmlFor="esqueci-email">Email</label>
              <input
                id="esqueci-email"
                type="email"
                name="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="seuemail@exemplo.com"
                autoFocus
              />
            </div>
            <div className="actions" style={{ marginTop: 0 }}>
              <button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar link'}
              </button>
            </div>
          </form>
        </>
      )}
    </Modal>
  );
}
